'use client';

import type { ActionBoxData } from '@zoomit/editor';
import { ArrowLeft } from '@zoomit/icons';
import { cn, Flex } from '@zoomit/primitives';
import { Anchor, cssVar, theme, Typography } from '@zoomit/zoomit-ds';

type Props = {
  blockData: ActionBoxData;
  className: string;
};

export const ActionBoxBlockData = (props: Props) => {
  const { blockData, className } = props;
  return (
    <Flex
      className={cn('bg-background2 relative z-[1] rounded-sm', className)}
      gap={1.6}
      flexDirection="column"
    >
      <Typography variant="h5">{blockData.title}</Typography>
      <Typography variant="callout" lineHeight={2} fontSize={1.6}>
        {blockData.description}
      </Typography>
      <Anchor
        href={blockData.link}
        rel={blockData.noFollow ? 'nofollow' : undefined}
        variant={blockData.buttonType.value === 'thick' ? 'contained' : 'outline'}
        colorScheme={blockData.buttonType.value === 'thick' ? 'default' : 'secondary'}
        fontWeight={900}
        size="fit"
      >
        {blockData.buttonTitle}{' '}
        {blockData.buttonType.value === 'thick' && <ArrowLeft fill={cssVar(theme.primary2)} />}
      </Anchor>
    </Flex>
  );
};
